var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"9a3e5add4c03855c3f18758dd6bce1ab86a4d6a2"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

import { sentryClientBeforeSend } from './src/utils/sentryRequestPiiStrip';
import { SENTRY_IGNORE_ERRORS } from './src/utils/sentryIgnoreErrors';

// DSN is safe to expose - it only allows sending errors, not reading data
const SENTRY_DSN = 'https://4364fefb8fd517f9f5c9b14863c0278b@o4505597795500032.ingest.us.sentry.io/4505597883842560';

// Initialize Sentry for all environments except local development
// VERCEL_ENV is automatically set by Vercel: 'production', 'preview', or 'development'
const isLocalDev = typeof window !== 'undefined' && window.location.hostname === 'localhost';

if (!isLocalDev) {
  Sentry.init({
    dsn: SENTRY_DSN,
    tracesSampleRate: 0,
    release: process.env.VERCEL_GIT_COMMIT_SHA,
    environment: process.env.NEXT_PUBLIC_VERCEL_ENV || 'unknown',

    // Two hooks, composed in src/utils/sentryRequestPiiStrip.ts:
    //
    // 1. Credential redaction (GB #1561). The browser SDK's HttpContext
    //    integration sets request.url from window.location.href and Referer
    //    from document.referrer, and navigation breadcrumbs record from/to —
    //    so on /reset-password?oobCode=... a LIVE Firebase password-reset
    //    token reaches Sentry through three channels. oobCode/code/token
    //    values are replaced with [Filtered]; the parameter names, the path,
    //    and everything else survive. No body/cookie strip here: browser
    //    events carry neither, and their headers are diagnosis worth keeping.
    // 2. The flood guard: cap identical error fingerprints per rolling window
    //    so one hydration storm or render loop cannot exhaust the org-wide
    //    ingest quota and 429 away unrelated checkout/cart/payment errors.
    //    See src/utils/sentryFloodGuard.ts for the full rationale.
    //
    // Both run AFTER ignoreErrors and denyUrls (below), which filter events
    // before beforeSend sees them at all.
    beforeSend: sentryClientBeforeSend,

    // Ignore errors from third-party scripts (ad blockers, tracking protection).
    // The list lives in src/utils/sentryIgnoreErrors.ts so tests can assert an
    // instrumented message isn't accidentally muted by it (matching is by
    // SUBSTRING — see that file). GB #1527.
    ignoreErrors: SENTRY_IGNORE_ERRORS,

    // Ignore errors originating from these third-party domains
    denyUrls: [
      // Pinterest
      /ct\.pinterest\.com/i,
      // Facebook
      /connect\.facebook\.net/i,
      /graph\.facebook\.com/i,
      // Google Analytics/Ads
      /google-analytics\.com/i,
      /googleadservices\.com/i,
      /googlesyndication\.com/i,
      // Other ad/tracking networks
      /doubleclick\.net/i,
      /hotjar\.com/i,
      /clarity\.ms/i,
    ],
  });
}